export enum InvoiceStatuses {
  New,
  SentToBilling,
  SentToReview,
  BillingRejected,
  Paid,
  ReviewApproved,
  ReviewRejected,
}
